import axios from "axios";
import { instanceTokenLess } from "../../../axios";
import instance from "../../../axios";
export const API_URL = `${process.env.REACT_APP_API_URL}/coupon-categories`;
export const BASE_URL = `${process.env.REACT_APP_API_URL}`;
// CREATE =>  POST: add a new StaffUser to the server

export function createItem(queryParams) {
  return instanceTokenLess
    .post(`${process.env.REACT_APP_API_URL}/coupon-categories/create`, queryParams)
    .then((res) => {
      return res;
    });
}
// READ
// export function getList(queryParams) {
//   return axios.post(`${API_URL}/list`, queryParams);
// }
export function getCompany(queryParams) {
  return instance
    .post(`${BASE_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}
export function getList(queryParams) {
  
  return instanceTokenLess
    .post(`${process.env.REACT_APP_API_URL}/coupon-categories/list`, queryParams)
    .then((res) => {
      return res;
    });
}


export function fetchCompanyDropdownList(queryParams) {
  return instance
    .post(`${process.env.REACT_APP_API_URL}/company/dropdown/list`, queryParams)
    .then((res) => {
      return res;
    });
}
export function fetchCompanyDropdownList1(queryParams) {
  return instance
    .post(`${process.env.REACT_APP_API_URL}/v3/dropdown/company/short`, queryParams)
    .then((res) => {
      return res;
    });
}
export function getItemById(id) {
  const selectedCompany = localStorage.getItem('selectedCompanyy');
  if (!selectedCompany) {
    return Promise.reject(new Error("No company selected"));
  }
  const payload = {
    id: id,
    company: selectedCompany, 
  };
  return instanceTokenLess.post(`${API_URL}/get/${id}`, payload)
    .then((res) => {
      return res;
    });
}

export function findItem(queryParams) {
  return axios.post(`${API_URL}/find`, { queryParams });
}



export function updateItem(item) {
  // Retrieve the selected company from local storage
  const selectedCompany = localStorage.getItem('selectedCompanyy');

  // Check if a company was selected in local storage
  if (!selectedCompany) {
    // Handle the case where no company is selected in local storage
    return Promise.reject(new Error("No company selected"));
  }

  // Add the "company" property to the item object
  item.company = selectedCompany.trim().toLowerCase();

  return instanceTokenLess.post(`${API_URL}/update/${item._id}`, item)
    .then((res) => {
      return res;
    });
}
export function updateStatus(item) {
  // Retrieve the selected company from local storage
  const selectedCompany = localStorage.getItem('selectedCompanyy');

  // Check if a company was selected in local storage
  if (!selectedCompany) {
    // Handle the case where no company is selected in local storage
    return Promise.reject(new Error("No company selected"));
  }

  // Add the "company" property to the item object
  item.company = selectedCompany.trim().toLowerCase();

  return instanceTokenLess.post(`${API_URL}/status/${item._id}`, item)
    .then((res) => {
      return res;
    });
}


// export function updateItemsStatus(ids, status, company = "GJ") {
//   const payload = {
//     company: company.trim().toLowerCase(),
//   };

//   return instanceTokenLess
//     .post(`${API_URL}/updateStatusForitems`, { ...payload, ids, status })
//     .then((res) => {
//       return res;
//     });
// }

export function updateItemsStatus(ids, status) {
  
  return instanceTokenLess.post(`${API_URL}/updateStatusForitems`, {
    ids,
    status
  })
  .then((res) => {
    return res;
  });
}

export function deleteItem(id) {
  // Retrieve the selected company from local storage
  const selectedCompany = localStorage.getItem('selectedCompanyy');

  // Check if a company was selected in local storage
  if (!selectedCompany) {
    // Handle the case where no company is selected in local storage
    return Promise.reject(new Error("No company selected"));
  }

  const payload = {
    company: selectedCompany.trim().toLowerCase()
  };

  return instanceTokenLess.post(`${API_URL}/delete/${id}`, payload)
    .then((res) => {
      return res;
    });
}

export function deleteItems(ids) {
  // Retrieve the selected company from local storage
  const selectedCompany = localStorage.getItem('selectedCompanyy');

  // Check if a company was selected in local storage
  if (!selectedCompany) {
    // Handle the case where no company is selected in local storage
    return Promise.reject(new Error("No company selected"));
  }

  const payload = {
    company: selectedCompany.trim().toLowerCase(),
    ids: ids
  };

  return instanceTokenLess.post(`${API_URL}/deleteitems`, payload)
    .then((res) => {
      return res;
    });
}
